import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import { Spinner } from 'react-bootstrap';
import Resoconto from '~src/components/Removebg/Resoconto';
import Storico from '~src/components/Removebg/Storico';
import { fetchAiCredits } from '~graphql/controllers/fetchAiCredits';
import { fetchAiCreditsOrders } from '~graphql/controllers/fetchAiCreditsOrders';
import { onErrorShowMessage } from '~src/errors';
import { initAiCreditPackagesModal } from '~src/sidebar/initAiCreditPackagesModal';
import { initAiCreditsInfoModal } from '~src/sidebar/initAiCreditsInfoModal';

const Loader = () => (
  <div className="text-center">
    <Spinner animation="grow" variant="info" />
  </div>
);

const CreditsPage = () => {
  const [loadingCredits, setLoadingCredits] = useState(true);
  const [loadingOrders, setLoadingOrders] = useState(true);
  const [orders, setOrders] = useState([]);
  const [credits, setCredits] = useState({});

  useEffect(() => {
    // Ensure the AI Credit Packages modal is initialized (events/bindings)
    try {
      initAiCreditPackagesModal();
    } catch (e) {
      // non-blocking
    }
    try {
      initAiCreditsInfoModal();
    } catch (e) {
      // non-blocking
    }

    setLoadingOrders(true);
    fetchAiCreditsOrders()
      .then((data) => {
        if (!data || !data.edges || !data.edges[0]) {
          setOrders([]);
        } else {
          setOrders(data.edges);
        }
        setLoadingOrders(false);
      })
      .catch((err) => {
        console.error(err);
        onErrorShowMessage();
      });
  }, []);

  useEffect(() => {
    setLoadingCredits(true);
    fetchAiCredits()
      .then((data) => {
        if (!data || !data.edges || !data.edges[0]) {
          setCredits({
            freeCreditsAmount: 0,
            paidCreditsAmount: 0,
          });
        } else {
          setCredits(data.edges[0]);
        }
        setLoadingCredits(false);
      })
      .catch((err) => {
        console.error(err);
        onErrorShowMessage();
      });
  }, []);

  return (
    <div className="credits-content">
      <section className="credits-hero">
        <div className="credits-hero__headline">
          <h1>Crediti Intelligenza Artificiale</h1>
          <p className="credits-hero__sub">
            Controlla il saldo, acquista e consulta lo storico dei crediti AI.
          </p>
        </div>
        <div className="credits-hero__actions">
          <button
            type="button"
            className="credits-hero__cta"
            onClick={() => {
              try {
                $('#aiCreditPackagesModal').modal('show');
              } catch (e) {
                // non-blocking
              }
            }}
          >
            Acquista crediti
          </button>
          <button
            type="button"
            className="credits-hero__cta credits-hero__cta--secondary"
            onClick={() => {
              try {
                $('#aiCreditsInfoModal').modal('show');
              } catch (e) {
                // non-blocking
              }
            }}
          >
            Come funzionano?
          </button>
        </div>
      </section>

      <section className="credits-list">
        {loadingCredits ? <Loader /> : <Resoconto credits={credits} flat />}

        {!loadingOrders && orders.length > 0 && (
          <Storico orders={orders} flat />
        )}
      </section>
    </div>
  );
};

export default CreditsPage;
